import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { BottomSheetContentLayout, Menu } from 'seagull';
import { ChevronRight24 } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
export const GetMobileAddFilterListTID = (parentTestId)=>getTestIds(parentTestId);
export const MobileAddFilterList = (param)=>{
    let { testId, filterLabels, availableFilters, onSelect, groups } = param;
    const { MobileAddFilterListTID } = useMemo(()=>GetMobileAddFilterListTID(testId), [
        testId
    ]);
    const toFilterItem = (filter)=>({
            id: String(filter),
            testId: MobileAddFilterListTID.FilterOption(String(filter)),
            body: filterLabels[filter],
            suffixIcon: /*#__PURE__*/ _jsx(ChevronRight24, {}),
            onClick: ()=>onSelect(filter)
        });
    const buildGroupedItems = (filterGroups)=>filterGroups.flatMap((group)=>{
            const visibleFilters = group.filters.filter((f)=>availableFilters.includes(f));
            if (visibleFilters.length === 0) return [];
            return [
                {
                    id: "group-".concat(group.label),
                    isSectionHeader: true,
                    label: group.label
                },
                ...visibleFilters.map(toFilterItem)
            ];
        });
    const buildFlatItems = ()=>availableFilters.map(toFilterItem);
    const items = groups ? buildGroupedItems(groups) : buildFlatItems();
    return /*#__PURE__*/ _jsx(BottomSheetContentLayout, {
        header: {
            title: 'Add filter',
            paddingBottom: 8
        },
        children: /*#__PURE__*/ _jsx(Menu, {
            dimensions: {
                width: 'auto'
            },
            items: items
        })
    });
};
